module.exports = __webpack_public_path__ + "img/wf-finishing-position-8.fe5a70a9.svg";